import React from 'react';

import type { NavigationProps } from 'common/components/Reclamation/Navigation';
import Navigation from 'common/components/Reclamation/Navigation';

type ReclamationDrawerFooterProps = NavigationProps;

const ReclamationDrawerFooter = (props: ReclamationDrawerFooterProps) => (
  <footer data-testid="reclamation-drawer-footer">
    <Navigation {...props} />
  </footer>
);

export default ReclamationDrawerFooter;
